export enum SocialTopicStatusEnum {
    active = 'Active',
    paused = 'Paused',
    standby = 'Standby',
    expired = 'Expired',
    moderated = 'Moderated',
    // front-end only
    activeStandby = 'Active Standby',
    pausedStandby = 'Paused Standby',
}
